export default {"src":"/_next/static/image/src/onboarding/AccountFeatures/feeding-guidelines.0c80ab933e7d013992f7e80368728719.svg","height":70,"width":69};